// API chat redirect URL mappings per environment.
// Traffic goes through the backend `/api/chat` endpoint, which signs the
// redirect with HMAC and applies access control before forwarding to the chat.
// Used for campaign redirections (mCreative).
const API_CHAT_URLS = {
  localhost: () => window.location.origin + "/api/chat",
  "staging.episto.fr": () => "https://staging.episto.fr/api/chat",
  "staging-gcp.episto.fr": () => "https://staging-gcp.episto.fr/api/chat",
  "app.episto.fr": () => "https://app.episto.fr/api/chat",
};

// Standalone chat app URL mappings per environment.
// Points directly at the chat SPA. Used for shareable end-user links
// (the "Links" page) rather than the backend `/api/chat` redirect.
const CHAT_APP_URLS = {
  localhost: () => window.location.origin + "/chat",
  "staging.episto.fr": () => "https://staging-chat.episto.fr",
  "staging-gcp.episto.fr": () => "https://staging-chat-gcp.episto.fr",
  "app.episto.fr": () => "https://chat.episto.fr",
};

const DEFAULT_API_CHAT_URL = "https://app.episto.fr/api/chat";
const DEFAULT_CHAT_APP_URL = "https://chat.episto.fr";

export function getChatBaseUrl() {
  const hostname = window.location.hostname;

  // PR environments use hostname-based URLs
  if (hostname.endsWith(".pr.episto.fr")) {
    return "https://" + hostname + "/api/chat";
  }

  return API_CHAT_URLS[hostname]?.() || DEFAULT_API_CHAT_URL;
}

export function getChatAppBaseUrl() {
  const hostname = window.location.hostname;

  if (hostname.endsWith(".pr.episto.fr")) {
    return "https://" + hostname + "/chat";
  }

  return CHAT_APP_URLS[hostname]?.() || DEFAULT_CHAT_APP_URL;
}

export { DEFAULT_API_CHAT_URL, DEFAULT_CHAT_APP_URL };
